<template>
  <v-select
    :multiple="multiple"
    :append-to-body="appendToBody"
    :calculate-position="withPopper"
    :select-on-tab="true"
    :clear-search-on-blur="() => true"
    :close-on-select="shouldCloseOnSelect"
    v-bind:value="value"
    v-on:input="$emit('input')"
    :components="{ OpenIndicator: value ? null : OpenIndicator }"
    @input="updatePopper"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #no-options="{ search, searching }">
      <span class="px-1">
        <p class="mb-0 p-3 text-center text-danger font-weight-medium" v-if="error">
          <slot name="error">An error occurred while loading the data. Please try again later.</slot>
        </p>
        <slot name="not-found" :search="search" v-else-if="searching">No results found for "{{ search }}"</slot>
        <slot name="no-options" v-else>Start typing to search</slot>
      </span>
    </template>

    <template #spinner="{ loading }">
      <div v-if="loading" class="loading-spinner">
        <b-spinner variant="secondary" small label="Searching..." />
      </div>
    </template>

    <template #option="option">
      <slot name="option" :option="option"></slot>
    </template>

    <template #search="{ attributes, events }">
      <slot name="input" :attributes="attributes" :events="events"></slot>
    </template>
  </v-select>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';
import VSelect from 'vue-select';
import { createPopper } from '@popperjs/core';
import { stripCSSUnit } from 'helpers/string';

export default {
  name: 'AkSelect',
  components: { BSpinner, VSelect },
  props: {
    appendToBody: {
      type: Boolean,
      required: false,
      default: true,
    },
    value: {},
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      popper: null,
      OpenIndicator: {
        render: (createElement) => createElement('i', { class: 'bi bi-caret-down-fill pr-1 iconColor' }),
      },
    };
  },
  computed: {
    shouldCloseOnSelect() {
      if (this.multiple) return false;
      return true;
    },
  },
  methods: {
    withPopper(dropdown, component, { width }) {
      dropdown.style.width = `${Number(stripCSSUnit(width.toString())) + 0.4}px`;
      dropdown.style.zIndex = 10000;
      this.popper = createPopper(component.$refs.toggle, dropdown, {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle('drop-up', state.placement === 'top');
            },
          },
        ],
      });

      return () => {
        this.popper?.destroy();
        this.popper = null;
      };
    },
    updatePopper() {
      this.$nextTick(() => {
        this.popper?.update();
      });
    },
  },
};
</script>
